// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 499 ? "4b8e6c4b" : chunkId) + "." + {"6":"a67f83cb42f2d910","32":"1bc6ea2a2c04f0cd","38":"38d3f68d5d1252c6","106":"e3513c66dab0543b","499":"ca67aca7cee284b4","543":"0ff98bdf871d19c5","631":"15f7c4e0c60228b1","706":"5440e5173ebe91a9"}[chunkId] + ".js";
};